import { Card, Col, Row, Skeleton } from '@repo/ui/components'

export const KycLoading = () => {
  return (
    <div className='px-md'>
      <Card className='p-xl rounded-sm'>
        <Col className='gap-4xl'>
          {/* Header */}
          <Row className='justify-between'>
            <Skeleton className='h-8 w-32' />
            <Skeleton className='h-6 w-16' />
          </Row>

          {/* Alert */}
          <div className='p-md border border-base-surface-5 rounded-md h-28'>
            <Row className='gap-sm items-center'>
              <Skeleton className='h-5 w-5 rounded-full flex-shrink-0 mt-xs' />
              <Skeleton className='h-4 flex-1' />
            </Row>
          </div>

          {/* Form Fields */}
          <Col className='gap-3xl'>
            {/* National Code */}
            {/* <div className='space-y-2'>
              <Skeleton className='h-4 w-24' />
              <Skeleton className='h-12 w-full' />
            </div>

            <div className='space-y-2'>
              <Skeleton className='h-4 w-24' />
              <Skeleton className='h-12 w-full' />
            </div> */}
            {/* Birth Date */}
            <div className='space-y-2'>
              <Skeleton className='h-4 w-20' />
              <Row className='gap-md'>
                <Skeleton className='h-12 flex-1' />
                <Skeleton className='h-12 flex-1' />
                <Skeleton className='h-12 flex-1' />
              </Row>
            </div>

            {/* Submit Button */}
            <div className='space-y-2'>
              <Skeleton className='h-4 w-20' />
              <Skeleton className='h-12 w-full' />
            </div>
          </Col>

          {/* Mobile KYC Link */}
          <Skeleton className='h-12 w-full' />
        </Col>
      </Card>
    </div>
  )
}
